import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, Outlet, useNavigate } from 'react-router-dom';

import * as AuthActions from '../../../../store/actions/auth.action';
import { getUser } from '../../../../store/selector/auth.selector';

const ProtectedRoute = ({ children, redirect = '/' }: any) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector(getUser);

  useEffect(() => {
    if (user) {
      const expirationDuraton =
        new Date(new Date(user.expired_at).getTime() + 60 * 60 * 12 * 1000).getTime() -
        new Date().getTime();

      setTimeout(() => {
        dispatch(AuthActions.Logout());
        navigate('/');
      }, expirationDuraton);
    }
  }, [user]);

  if (!user) {
    return <Navigate to={redirect} replace />;
  }

  return children ? children : <Outlet />;
};

export default ProtectedRoute;
